import { Button } from '@barfacil/barfacil-ui'
import { Menu } from 'lucide-react'

import { AppsMenu } from '@/app/panel/_components/apps-menu'
import { CompanyMenu } from '@/app/panel/_components/company-menu'
import { ProfileMenu } from '@/app/panel/_components/profile-menu'
import { useNavbarContext } from '@/app/panel/_contexts/navbar-context'

export const Header = () => {
  const { expanded, setExpanded } = useNavbarContext()

  return (
    <header className="container flex h-24 items-center justify-between px-4 lg:px-8">
      <Button
        className="lg:hidden"
        variant="ghost"
        size="icon"
        onClick={() => setExpanded(!expanded)}
      >
        <span className="sr-only">
          {expanded ? 'Minimizar navegação' : 'Maximizar navegação'}
        </span>

        <Menu size={32} />
      </Button>

      <div className="flex items-center gap-1 sm:gap-4 lg:ml-auto">
        <AppsMenu />
        <CompanyMenu />
        <ProfileMenu />
      </div>
    </header>
  )
}
